import { module } from 'modujs';

export default class InputSelect extends module {

    static get settings() {
        return {
            CLASSNAME: 'o-select',
            CLASS_OPEN: 'is-open',
            CLASS_FILLED: 'is-filled',
            CLASS_SELECTED: 'is-selected',
            CLASS_DISABLED: '-disabled',
        }
    }

    constructor(m) {
        super(m);

        // DOM Elements
        this.$el = this.el
        this.$select = this.$el.querySelector('select')
        this.$options = Array.from(this.$select.querySelectorAll('option'))
        this.$lang = this.$el.dataset.lang

        // Vars
        this.$selectedItem = null
        // this.isActive = window.matchMedia('(hover: hover)').matches

        // Events
        this.$select.addEventListener('change', this.onSelectUpdate = () => this.selectUpdate(true))
    }

    init() {

        this.$el.classList.add(InputSelect.settings.CLASSNAME)

        // if(!this.isActive) {
        //     this.$el.classList.add(InputSelect.settings.CLASS_DISABLED)
        //     return
        // }

        // Generate custom select
        const $list = document.createElement('div')
        $list.setAttribute('class', `${InputSelect.settings.CLASSNAME}_list`)
        $list.setAttribute('aria-hidden', 'true')
        this.$el.append($list)

        this.$items = []
        this.$options.forEach($option => {

            if($option.disabled) {
                return
            }

            const $item = document.createElement('button')
            $item.setAttribute('class', `${InputSelect.settings.CLASSNAME}_item`)
            $item.setAttribute('type', 'button')
            $item.dataset.value = $option.value
            $list.append($item)
            $item.innerHTML = $option.innerHTML
            $item.addEventListener('click', () => this.selectItem($item, true))

            if(this.$lang == $option.text.toLowerCase()) {
                this.selectItem($item)
            }

            this.$items.push($item)
        })

        // Add trigger button
        this.$trigger = document.createElement('button')
        this.$trigger.setAttribute('class', `${InputSelect.settings.CLASSNAME}_trigger`)
        this.$trigger.setAttribute('type', 'button')
        this.$trigger.innerHTML = 'Select option'
        this.$trigger.addEventListener('click', this.onTriggerClick = () => this.toggle())
        this.$el.append(this.$trigger)
    }

    toggle() {

        if(this.isOpen) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {

        if(this.isOpen) {
            return
        }

        this.$el.classList.add(InputSelect.settings.CLASS_OPEN)
        this.isOpen = true

        // Close select on click outside
        if(this.isActive) {
            document.addEventListener('click', this.onClickOutside = e => {
                if (!this.$el.contains(e.target)) {
                    this.close()
                }
            })
        }
    }

    close() {

        if(!this.isOpen) {
            return
        }

        this.$el.classList.remove(InputSelect.settings.CLASS_OPEN)
        this.isOpen = false

        if(this.isActive) {
            document.removeEventListener('click', this.onClickOutside)
        }
    }

    selectUpdate(change=false) {
        if(this.$select.value !== '') {
            this.$el.classList.add(InputSelect.settings.CLASS_FILLED)
            if(change) {
                location.href = this.$select.value
            }
        } else {
            this.$el.classList.remove(InputSelect.settings.CLASS_FILLED)
        }

        this.close()
    }

    selectItem($item, change=false) {

        if(this.$selectedItem === $item) {
            this.close()
            return
        }

        if(this.$selectedItem) {
            this.$selectedItem.classList.remove(InputSelect.settings.CLASS_SELECTED)
        }

        $item.classList.add(InputSelect.settings.CLASS_SELECTED)
        this.$selectedItem = $item
        this.$select.value = $item.dataset.value
        this.selectUpdate(change)
    }


    destroy() {
        this.$select.removeEventListener('change', this.onSelectUpdate)

        if(this.isActive) {
            this.$trigger.removeEventListener('click', this.onTriggerClick)
        }
    }
}
